/** Hourly weather + adjusted-pace line chart (temp, dew, solar DNI, pace). */

export const DNI_KEYS = ['direct_normal_irradiance', 'dni_wm2', 'dni'];

export const DNI_YELLOW = '#f5c518';

export function dniFromRow(row) {
  if (!row || typeof row !== 'object') return null;
  for (const key of DNI_KEYS) {
    if (row[key] == null || row[key] === '') continue;
    const n = Number(row[key]);
    if (Number.isFinite(n)) return n;
  }
  return null;
}

export function dniAxisMax(values) {
  const nums = (values || []).filter((v) => v != null && Number.isFinite(Number(v)));
  const peak = nums.length ? Math.max(...nums.map(Number)) : 0;
  return Math.max(800, Math.ceil(peak / 100) * 100);
}

export function buildWeatherChartData({ weatherData = [], paceData = [], colors = {} }) {
  const dni = weatherData.map(dniFromRow);
  return {
    labels: paceData.map((d) =>
      new Date(d.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    ),
    datasets: [
      {
        label: 'Temperature (°F)',
        data: weatherData.map((d) => d.temperature_2m || 0),
        borderColor: colors.temperature,
        backgroundColor: colors.temperature,
        fill: false,
        yAxisID: 'y-left',
      },
      {
        label: 'Mugginess (°F)',
        data: weatherData.map((d) => d.dew_point_2m || 0),
        borderColor: colors.dewPoint,
        backgroundColor: colors.dewPoint,
        fill: false,
        yAxisID: 'y-left',
      },
      {
        label: 'Solar DNI (W/m²)',
        data: dni,
        borderColor: colors.dni || DNI_YELLOW,
        backgroundColor: colors.dni || DNI_YELLOW,
        fill: false,
        yAxisID: 'y-dni',
        spanGaps: false,
      },
      {
        label: 'Adjusted Pace (min/mile)',
        data: paceData.map((d) => d.adjusted_pace || 0),
        borderColor: colors.pace,
        backgroundColor: colors.pace,
        fill: false,
        yAxisID: 'y-right',
      },
    ],
  };
}
